
import Title from '~/components/common/page-title.vue'

export default {
  name: 'AiWorkspaceKv',
  components: {
    Title
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: '/images/vision/kv-img1.png'
    }
  }
}
